(function () {
  function setup(root) {
    if (root.__faqInit) return;
    root.__faqInit = true;

    var navItems = Array.prototype.slice.call(root.querySelectorAll('.faq-nav-item'));
    var qnas = Array.prototype.slice.call(root.querySelectorAll('.faq-qna'));
    var titles = Array.prototype.slice.call(root.querySelectorAll('.faq-cat-title'));
    var nav = root.querySelector('.faq-renew-nav');
    var chips = root.querySelector('.faq-chips');
    var thumb = root.querySelector('.faq-chip-bar-thumb');
    var lockSpy = false;
    var lockTimer;

    if (nav && chips && !thumb) {
      var bar = document.createElement('div');
      bar.className = 'faq-chip-bar';
      thumb = document.createElement('div');
      thumb.className = 'faq-chip-bar-thumb';
      bar.appendChild(thumb);
      nav.appendChild(bar);
    }

    function isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    function openQna(target) {
      qnas.forEach(function (qna) {
        var answer = qna.querySelector('.faq-a');
        if (qna === target) {
          qna.classList.add('active');
          if (answer) answer.style.maxHeight = answer.scrollHeight + 'px';
        } else {
          qna.classList.remove('active');
          if (answer) answer.style.maxHeight = '0';
        }
      });
    }

    function syncThumb() {
      if (!chips || !thumb) return;
      if (chips.scrollWidth === 0) return;
      var max = chips.scrollWidth - chips.clientWidth;
      var visible = chips.clientWidth / chips.scrollWidth;
      var w = max > 0 ? Math.max(visible * 0.5, 0.12) : 1;
      var progress = max > 0 ? chips.scrollLeft / max : 0;
      thumb.style.width = (w * 100) + '%';
      thumb.style.transform = 'translateX(' + (progress * (1 - w) / w * 100) + '%)';
    }

    function setActive(tabId) {
      navItems.forEach(function (item) {
        var on = item.getAttribute('data-tab-id') === tabId;
        item.classList.toggle('active', on);
        if (on && chips && isMobile()) {
          var railRect = chips.getBoundingClientRect();
          var cRect = item.getBoundingClientRect();
          chips.scrollLeft += (cRect.left + cRect.width / 2) - (railRect.left + railRect.width / 2);
        }
      });
    }

    function stickyOffset() {
      if (isMobile() && nav) {
        var top = parseFloat(getComputedStyle(nav).top) || 0;
        return top + nav.offsetHeight + 14;
      }
      return 100;
    }

    function syncActive() {
      if (lockSpy || titles.length === 0) return;
      var base = stickyOffset() + 10;
      var current = titles[0];
      titles.forEach(function (t) {
        if (t.getBoundingClientRect().top <= base) current = t;
      });
      if (window.innerHeight + window.pageYOffset >= document.documentElement.scrollHeight - 4) {
        current = titles[titles.length - 1];
      }
      var id = current.getAttribute('id');
      var active = root.querySelector('.faq-nav-item.active');
      if (!active || active.getAttribute('data-tab-id') !== id) setActive(id);
    }

    if (navItems.length > 0) {
      navItems[0].classList.add('active');
    }
    openQna(qnas[0] || null);
    syncThumb();
    requestAnimationFrame(syncThumb);
    window.addEventListener('load', syncThumb);

    function releaseSpy(targetTop, tries) {
      clearTimeout(lockTimer);
      lockTimer = setTimeout(function () {
        if (tries > 0 && Math.abs(window.pageYOffset - targetTop) > 40) {
          releaseSpy(targetTop, tries - 1);
        } else {
          lockSpy = false;
          syncActive();
        }
      }, 450);
    }

    navItems.forEach(function (item) {
      item.addEventListener('click', function (event) {
        event.preventDefault();
        var tabId = item.getAttribute('data-tab-id');
        var target = root.querySelector('.faq-cat-title[id="' + tabId + '"]');
        lockSpy = true;
        setActive(tabId);
        if (target) {
          var top = target.getBoundingClientRect().top + window.pageYOffset - stickyOffset();
          window.scrollTo({ top: top, behavior: 'smooth' });
          releaseSpy(top, 10);
        } else {
          releaseSpy(window.pageYOffset, 0);
        }
      });
    });

    qnas.forEach(function (qna) {
      var question = qna.querySelector('.faq-q');
      var answer = qna.querySelector('.faq-a');
      if (!question || !answer) return;
      question.addEventListener('click', function () {
        if (qna.classList.contains('active')) {
          qna.classList.remove('active');
          answer.style.maxHeight = '0';
        } else {
          openQna(qna);
        }
      });
    });

    if (chips) {
      chips.addEventListener('scroll', syncThumb, { passive: true });
    }
    window.addEventListener('resize', syncThumb);
    window.addEventListener('scroll', syncActive, { passive: true });
    window.addEventListener('scrollend', function () {
      if (lockSpy) {
        lockSpy = false;
        clearTimeout(lockTimer);
      }
    });
    requestAnimationFrame(syncActive);
  }

  function initVideoModal() {
    if (window.__faqVideoModalReady) return;
    window.__faqVideoModalReady = true;

    var modal = document.createElement('div');
    modal.className = 'faq-modal';
    modal.setAttribute('aria-hidden', 'true');
    modal.innerHTML =
      '<div class="faq-modal-overlay" data-faq-close></div>' +
      '<div class="faq-modal-dialog" role="dialog" aria-modal="true">' +
      '<button class="faq-modal-close" type="button" data-faq-close aria-label="Close">&times;</button>' +
      '<div class="faq-modal-body"></div>' +
      '</div>';
    document.body.appendChild(modal);
    var body = modal.querySelector('.faq-modal-body');

    function onKey(event) {
      if (event.key === 'Escape') closeModal();
    }
    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      body.innerHTML = '';
      document.removeEventListener('keydown', onKey);
    }
    function openModal(tpl) {
      body.innerHTML = '';
      body.appendChild(tpl.content.cloneNode(true));
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.addEventListener('keydown', onKey);
    }

    modal.addEventListener('click', function (event) {
      if (event.target.hasAttribute('data-faq-close')) closeModal();
    });

    document.addEventListener('click', function (event) {
      var btn = event.target.closest('.faq-video-btn');
      if (!btn) return;
      var id = btn.getAttribute('data-faq-video');
      var tpl = id ? document.getElementById(id) : null;
      if (!tpl || !tpl.content) return;
      event.preventDefault();
      openModal(tpl);
    });
  }

  function initAll() {
    document.querySelectorAll('.faq-renew-section').forEach(setup);
    initVideoModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector && event.target.querySelector('.faq-renew-section');
    if (root) {
      root.__faqInit = false;
      setup(root);
    }
  });

  document.addEventListener('shopify:section:select', initAll);
})();
